import { oauthLogger } from './logging.utils';
import { HttpError } from '../types/http-error';
const MAX_SUCCESS_CODE = 399;
/**
 * Bei einem Client- oder Server-Fehler wird die Antwort zurückgewiesen
 * @param response
 */
export function handleErrorStatus(response) {
  if (response.status <= MAX_SUCCESS_CODE) {
    oauthLogger.info(`Anfrage an ${response.url} war erfolgreich!`);
    return Promise.resolve(response);
  }
  else {
    oauthLogger.info(`Anfrage an ${response.url} war NICHT erfolgreich!`);
    return Promise.reject(new HttpError(response));
  }
}
/**
 * Behandelt eine Antwort unter Berücksichtung von CORB, d.h. der emittierte Security-Token im Body der Antwort wird unter bestimmten Voraussetzungen entfernt.
 * @see Weitere Infos über CORB unter https://fetch.spec.whatwg.org/#corb
 * @param response
 */
export function handleCorb(response) {
  const commonCorbMimeTypes = ['application/json', 'text/json', 'text/plain', 'text/html', 'text/xml', 'application/xml'];
  if (!commonCorbMimeTypes.includes(new Headers(response.headers).get('Content-Type'))) {
    return Promise.resolve(response);
  }
  oauthLogger.info('Prüfung bezüglich CORB wird durchgeführt.');
  return response.text().then((txt) => {
    const newBodyText = txt == null ? null : txt.replace(/^\)\]\}',?\n/, '');
    if (newBodyText !== txt && response.status === 206) {
      const headers = new Headers(response.headers);
      headers.set('X-API-BLOCKED', '1');
      return Promise.reject(new HttpError(new Response(txt, {
        headers,
        status: response.status,
        statusText: `Der Zugriff auf die Antwort zur Anfrage mit der Url "${response.url}" wird wegen CORB blockiert!`,
      })));
    }
    return Promise.resolve(new Response(newBodyText, {
      headers: response.headers,
      status: response.status,
      statusText: response.statusText,
    }));
  });
}
//# sourceMappingURL=response.utils.js.map
